export default __webpack_public_path__ + "static/media/google-maps.dd718ed7.PNG";